import { Component, OnInit } from "@angular/core";
import { RouterService } from "@app/root-store/router.service";

@Component({
    selector: "app-login-container",
    templateUrl: "./login-container.component.html",
})
export class LoginContainerComponent implements OnInit {
    constructor(private readonly routerService: RouterService) {}

    ngOnInit() {
        this.routerService.updateBackButton({ action: null });
    }
}
